import { useEffect, useRef } from 'react';

import {
  useGetMyInfoMutation,
  useLazyExtendedInfoQuery,
} from '@/api/queries/user';
import i18n from '@/i18n';
import { changeLoginRequesLoadingStatus } from '@/redux/reducers/appReducer';
import { changeOnboardingStatus } from '@/redux/reducers/userReducer';
import { useAppDispatch, useAppSelector } from '@/redux/store';

const useGetMyInfoAfterLogin = (): void => {
  const token = useAppSelector((state) => state.user.token);
  const hasRequestSend = useRef<boolean>(false);
  const [getMyInfo] = useGetMyInfoMutation();
  const [getExtendedInfo] = useLazyExtendedInfoQuery();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const initDataIsExist = !!Telegram?.WebApp?.initData;

    if (token && !initDataIsExist && !hasRequestSend.current) {
      hasRequestSend.current = true;
      getMyInfo()
        .unwrap()
        .then((response) => {
          dispatch(changeOnboardingStatus(true));
          getExtendedInfo();
          i18n.changeLanguage(response.language);
        })
        .finally(() => dispatch(changeLoginRequesLoadingStatus(false)));
    }
  }, [token]);
};

export { useGetMyInfoAfterLogin };
